import billerHttp from "services/axios.services/instances/billerHttp";

export interface BillerRegion {
  _id: string;
  regionCode: string;
  regionName: string;
}

export interface BillerRegionsResponse {
  returnItems: number;
  billerRegions: BillerRegion[];
  status: boolean;
  statusCode: number;
  message: string;
  errors: any;
}

export interface FetchBillerRegionsRequest {
  search: string; // "IND"
  page?: number | null;
  limit?: number | null;
}

const billerRegionsService = {
  fetchRegions: async ({
    search = "IND",
    page,
    limit,
  }: FetchBillerRegionsRequest): Promise<BillerRegionsResponse> => {
    const response = await billerHttp.get<BillerRegionsResponse>(
      `/api/biller/regions/all`,
      { params: { search, page, limit } },
    );

    return response.data;
  },
};

export default billerRegionsService;
